import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=e28abda4"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./NotFound.css?vue&type=custom&index=0&blockType=styles&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fpages%2FNotFound%2FNotFound.vue&scoped=true&external"
if (typeof block0 === 'function') block0(component)

export default component.exports